import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { ISubmissionSidebarPanel } from './interfaces';
import { ContentPanel } from '../../../../../../components/ContentPanel';
import { Alert } from '@components/Alert';
import { Box, Button, Typography } from '@mui/material';
import { CompetitionDetailsList } from '../../../components/CompetitionDetailsList';

export const SubmissionSidebarPanel: React.FC<ISubmissionSidebarPanel> = ({
  status,
  onRegisterBtnClick,
  onWithdrawBtnClick,
  readOnly = false,
  description,
  discipline,
  startDate,
  endDate,
  statusName,
  formatName,
  participants,
  weaponGroups = [],
  registerBlockedByWeaponGroup = false,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Box>
      <ContentPanel borderRadius="none">
        {status === 'registered' && !readOnly && (
          <Alert
            severity="success"
            sx={{
              mb: '10px',
            }}
            content={t('competitions:portal.details.enrolled')}
          />
        )}

        {description && (
          <Typography
            variant="body2"
            sx={{
              mb: '15px',
              whiteSpace: 'pre-line',
            }}
          >
            {description}
          </Typography>
        )}

        <Typography
          variant="body2"
          sx={{
            mb: '15px',
          }}
          color="text.secondary"
        >
          {discipline}
        </Typography>

        <CompetitionDetailsList
          startDate={startDate}
          endDate={endDate}
          statusName={statusName}
          formatName={formatName}
          participants={participants}
          weaponGroups={weaponGroups}
        />

        {!readOnly && status === 'not-registered' && onRegisterBtnClick ? (
          <Fragment>
            {registerBlockedByWeaponGroup ? (
              <Alert
                severity="warning"
                sx={{
                  mt: '10px',
                }}
                content={t(
                  'competitions:portal.details.shootingClearanceRequired'
                )}
              />
            ) : null}
            <Button
              variant="contained"
              color="primary"
              fullWidth
              disabled={registerBlockedByWeaponGroup}
              sx={{
                mt: '10px',
              }}
              onClick={onRegisterBtnClick}
            >
              {t('competitions:portal.details.registerButton')}
            </Button>
          </Fragment>
        ) : null}

        {!readOnly && status === 'registered' && onWithdrawBtnClick && (
          <Button
            variant="outlined"
            color="error"
            fullWidth
            sx={{
              mt: '10px',
            }}
            onClick={onWithdrawBtnClick}
          >
            {t('competitions:portal.details.withdrawButton')}
          </Button>
        )}
      </ContentPanel>
    </Box>
  );
};
